import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-1 text-sm text-foreground-600"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="whitespace-nowrap transition-colors hover:text-primary-600"
              >
                {item.label}
              </Link>
            ) : (
              <span
                aria-current={isLast ? 'page' : undefined}
                className={
                  isLast
                    ? 'whitespace-nowrap font-medium text-foreground-800'
                    : 'whitespace-nowrap'
                }
              >
                {item.label}
              </span>
            )}
            {!isLast && (
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            )}
          </span>
        );
      })}
    </nav>
  );
}